<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('DailyCashierReportList') | ToUppercase">
                <vs-button class="float-left" color="success" type="filled" to="/report/dailyCashier/add">{{$t('AddDailyCashierReport')}}</vs-button>

                <vs-table :noDataText="$t('NoReportsFound')" max-items="14" pagination search :data="dailyCashierReports">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th sort-key="date">{{ $t("Date") }}</vs-th>
                        <vs-th sort-key="items">{{ $t("Items") }}</vs-th>
                        <vs-th>{{ $t("Actions") }}</vs-th>
                        <vs-th>{{ $t("Download") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].date_formated}}</vs-td>
                                <vs-td>{{ data[index].items.length}}</vs-td>
                                <vs-td>
                                    <vs-button color="primary" class="" @click="$router.push('/report/dailyCashier/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                </vs-td>
                                <vs-td class="grid justify-items-start">
                                    <vs-button class="float-left" color="primary" @click="exportPDF(data[index].id)" type="border" icon="picture_as_pdf">PDF</vs-button>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                dailyCashierReports: [],
                users: [],
                shifts: [],
            };
        },
        methods: {
            updateDailyCashierReports() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/report?type=dailyCashier')
                .then(function (response) {
                    thisIns.dailyCashierReports = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            exportPDF(reportId) {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.post("/report/generateDailyCashierReportPdf", {
                    id: reportId,
                }).then(function (response) {
                    window.open('/api/pdf/report/' + response.data + '?type=dailyCashier');

                    thisIns.$vs.notify({
                        text: "PDF uspečno generiran",
                        color: "success",
                    });
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri generiranju.",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            this.updateDailyCashierReports();
        },
    };
</script>